export default "__VITE_ASSET__ZIL5hPdH__"